import { useCallback, useEffect, useRef, useState } from 'react';

export type DirectionType = 'UP' | 'DOWN' | null;

/**
 * @author 이현우
 * window scroll 시 위아래 방향 구하는 Hook
 */
const useWindowScrollDirection = () => {
  const prevY = useRef<number>();
  const [direction, setDirection] = useState<DirectionType>(null);
  const [y, setY] = useState<number | null>(null);

  const handleChangeScrollListener = useCallback(() => {
    if (prevY.current != null) {
      if (prevY.current > scrollY) {
        setDirection('UP');
      } else if (prevY.current < scrollY) {
        setDirection('DOWN');
      } else {
        setDirection(null);
      }
    }

    prevY.current = scrollY;
    setY(scrollY);
  }, [setDirection]);

  useEffect(() => {
    window.addEventListener('scroll', handleChangeScrollListener);
    return () =>
      window.removeEventListener('scroll', handleChangeScrollListener);
  }, [handleChangeScrollListener]);

  return { direction, y };
};

export default useWindowScrollDirection;
